import React, { useState } from 'react';
import './SupportPage.css';

const SupportPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Support',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.email || !formData.message) return;
    
    // Construct mailto link as fallback/direct send
    const mailtoSubject = encodeURIComponent(`[Support Request] ${formData.subject} - ${formData.name}`);
    const mailtoBody = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nSubject: ${formData.subject}\n\nMessage:\n${formData.message}`
    );
    
    window.location.href = `mailto:ganeshglive@gmail.com?subject=${mailtoSubject}&body=${mailtoBody}`;
    setSubmitted(true);
  };

  const faqs = [
    {
      question: "How can I set a wallpaper on my home or lock screen?",
      answer: "Open the Ganpati Wallpaper HD app, select your favorite Ganpati wallpaper, tap the 'Set Wallpaper' or 'Download' button, and choose whether to apply it to your Home Screen, Lock Screen, or both."
    },
    {
      question: "Are all Ganpati wallpapers free to download?",
      answer: "Yes! All high-resolution Lord Ganesha wallpapers available in the app are 100% free to view, download, and set as your personal wallpaper."
    },
    {
      question: "How do I request image removal or report copyright concerns?",
      answer: "If you are the copyright holder of any image featured in our app and wish to have it removed or properly credited, please email us directly at ganeshglive@gmail.com with details of the content."
    },
    {
      question: "What should I do if wallpapers fail to load or download?",
      answer: "Ensure you have an active internet connection. If the issue persists, try clearing the app cache in your device settings or restarting the app. If you still encounter problems, feel free to contact us via email."
    },
    {
      question: "Can I submit my own Ganpati art or wallpapers?",
      answer: "We love featuring user-contributed artwork! You can send your high-res Lord Ganesha wallpapers to ganeshglive@gmail.com with your preferred attribution info."
    }
  ];

  return (
    <div className="support-container">
      <div className="support-content">
        
        {/* Hero Section */}
        <div className="support-hero">
          <h1>Ganpati Wallpaper Support</h1>
          <p>We are here to help! Get assistance, report issues, or send your feedback to our team.</p>
        </div>

        <div className="support-grid">
          
          {/* Direct Email Card */}
          <div className="support-card contact-card-highlight">
            <div className="contact-icon-wrapper">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <h2 className="card-title">Direct Support Email</h2>
            <p style={{ color: '#555', fontSize: '0.95rem', margin: '0 0 0.5rem 0' }}>
              For fast assistance, technical support, copyright inquiries, or feature requests, contact us directly at:
            </p>
            
            <div className="email-box">
              <a href="mailto:ganeshglive@gmail.com" className="email-address">
                ganeshglive@gmail.com
              </a>
              <a href="mailto:ganeshglive@gmail.com" className="email-btn">
                Send Mail
              </a>
            </div>

            <ul className="info-list">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF512F" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                <span><strong>Response Time:</strong> Within 24-48 hours</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF512F" strokeWidth="2"><path d="M22 11.08V12a10 10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                <span><strong>App Name:</strong> Ganpati Wallpaper HD</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF512F" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <span><strong>Support Coverage:</strong> Worldwide</span>
              </li>
            </ul>
          </div>

          {/* Quick Contact Form */}
          <div className="support-card">
            <h2 className="card-title">Send Us a Message</h2>
            <p style={{ color: '#555', fontSize: '0.95rem', marginBottom: '1.25rem' }}>
              Fill out the form below and it will launch your email client pre-filled with your message.
            </p>

            {submitted && (
              <div className="success-banner">
                Thank you! Your message draft has been opened in your mail application to send to <strong>ganeshglive@gmail.com</strong>.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Topic / Subject</label>
                <select
                  id="subject"
                  name="subject"
                  className="form-control"
                  value={formData.subject}
                  onChange={handleChange}
                >
                  <option value="General Support">General Support</option>
                  <option value="App Bug / Issue">App Bug / Issue</option>
                  <option value="Wallpaper Request">Wallpaper Request</option>
                  <option value="Copyright Removal">Copyright / Removal Request</option>
                  <option value="Feedback & Suggestions">Feedback & Suggestions</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-control"
                  placeholder="Describe your question or issue in detail..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Support Message
              </button>
            </form>
          </div>

        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">Q: {faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default SupportPage;
